import MP from '@alipay-inc/mpaas-device-fingerprint-sdk'
import { getRuntimeEnv } from './getRuntimeEnv'

// Define a constant for the token key to prevent typos
export const ALI_TOKEN_KEY = 'x-ali-token'

const runtimeEnv = getRuntimeEnv()
const workspaceid = runtimeEnv === 'PROD' ? 'paybyprod' : runtimeEnv === 'UAT' ? 'paybyuat' : 'paybysim'

const rpcParams = {
  appid:'PRI3A4F75F031013',
  workspaceid,
  baseURL:process.env.NODE_ENV === 'development'
    ? '/proxy/ali-fingerprint/mgw.htm'
    : 'https://fp-aen.botim.me/mgw.htm',
}

export async function initAliFingerprint() {
  const xAliToken = sessionStorage.getItem(ALI_TOKEN_KEY)
  if (xAliToken) {
    return Promise.resolve(xAliToken)
  }

  return MP.DFS.init({
    appName: 'checkout.payby.com',
    rpcParams,
    scene:1,
    configDisabled: {
      gpsDisabled: true,
    },
  }).then((res) => {
    console.log('aliInit', res)
    sessionStorage.setItem(ALI_TOKEN_KEY, res.data.token)
    return res.data.token
  }).catch((err) => {
    console.error('aliInit error', err.message)
    return Promise.reject(err)
  })
}

export async function updateAliFingerprint() {
  return MP.DFS.update({
    appName: 'checkout.payby.com',
    rpcParams,
    configDisabled: {
      gpsDisabled: true,
    },
  }).then((res) => {
    console.log('aliUpdate', res)
    sessionStorage.setItem(ALI_TOKEN_KEY, res.data.token)
    return res.data.token
  }).catch((err) => {
    console.error('aliUpdate error', err.message)
    return Promise.reject(err)
  })
}

window.updateAliFingerprint = updateAliFingerprint
